import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import Plyr from 'plyr';

export default class Engine extends Component {

  audioPlayer = null;

  configure() {
    return super.configure();
  }

  initialize() {

    this.wrapper = $('.player');
    this.element = $('#player');

    this.start();
    this.subscribeToEvents();
    return super.initialize();
  }

  start() {

    this.audioPlayer = new Plyr(this.element.get(0), {
      debug: false,
      controls: this.getControls(),
      hideControls: false,
      keyboard: {
        focused: false,
        global: false
      },
      fullscreen: {
        enabled:  false,
        fallback: false,
        iosNative: false
      }
    });

  }

  subscribeToEvents() {

    ['play', 'playing', 'stop', 'pause', 'ended', 'timeupdate'].forEach((event) => {
      this.audioPlayer.on(event, (data) => {
        if (['play'].indexOf(event) >= 0) {
          this.wrapper.removeClass('is-hidden');
        }
        this.onPlayerEvent(event, data);
      });
    });

    this.App.Events.subscribe('player.audio.playlistStatus', (data) => {
      this.setIsWithPlaylistStatus(data);
    });

    this.App.Events.subscribe('player.audio.play-next', (data) => {
      this.play(data.src, data.title || '');
    });

    $(document).on('click', '.player .is-navigate-control', (event) => {
      let element = $(event.currentTarget),
          direction = element.data('plyr');
      this.logger('Trying to play '+ direction +' track');
      this.App.Events.publish('player.audio.' + direction, true);
    });

  }

  play(src, title) {

    if (this.audioPlayer.source === src) {
      this.audioPlayer.play();
    } else {

      this.audioPlayer.source = {
        type:    'audio',
        title:   typeof title === 'string' ? title : '',
        sources: [
          {
            src:  src,
            type: 'audio/mp3'
          }
        ]
      };

      this.injectDownloadUrl(src);

      return this.audioPlayer.play();
    }
  }

  pause() {
    return this.audioPlayer.pause();
  }

  onPlayerEvent(event, data) {
    return this.App.Events.publish('player.audio.' + event, data.detail.plyr);
  }

  getControls() {
    return $('#audio-player-buttons-template').html();
  }

  injectDownloadUrl(url) {
    url = url.replace('.preview.', '.original.');
    this.wrapper.find('.is-file-download-button')
      .removeClass('is-hidden')
      .attr('href', url + '?download');
  }

  setIsWithPlaylistStatus(status) {
    if (status === true) {
      this.wrapper
        .removeClass('is-without-playlist')
        .find('.is-navigate-control')
        .prop('disabled', false);
    } else {
      this.wrapper
        .addClass('is-without-playlist')
        .find('.is-navigate-control')
        .prop('disabled', true);
    }
  }

}